export default function reducer(state = {
  processing: false,
  processed:  false,
  delinked:   false,
  errors:     {},
}, action) {
  switch (action.type) {
    case 'GET_USEROUTLETDELINK_PENDING':
    case 'GET_OUTLETDELINK_PENDING': {
      return {...state, processing: true, processed: false}
    }
    case 'GET_USEROUTLETDELINK_FULFILLED':
    case 'GET_OUTLETDELINK_FULFILLED': {
      return {
        ...state,
        delinked:  true,
        processed: true,
      }
    }
    case 'GET_USEROUTLETDELINK_REJECTED':
    case 'GET_OUTLETDELINK_REJECTED': {
      return {
        ...state, errors: action.payLoad
      }
    }
    case 'CLEAR_OUTLET_DELINK': {
      return {
        ...state,
        delinked:  false,
        processed: false,
      }
    }
  }

  return {...state};
}


// WEBPACK FOOTER //
// ./src/reducers/storeDelinkReducer.js